<template>
  <div>
    <el-table v-loading size="medium" stripe :data="users" style="width: 100%">
      <!--  -->
      <el-table-column align="center" label="#ID" width="60">
        <template #default="scope">
          <el-tooltip :content="scope.row._id">
            <i class="el-icon-user"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="firstName" label="First Name" width="180" />
      <!--  -->
      <el-table-column prop="lastName" label="Last Name" width="180" />
      <!--  -->
      <!-- User type -->
      <el-table-column align="center" label="User Type" width="170">
        <template #default="scope">
          <el-tag
            :type="
              scope.row.type === 'admin'
                ? 'danger'
                : scope.row.type === 'talent'
                ? 'info'
                : 'success'
            "
            effect="dark"
            is-rounded
            size="mini"
          >
            {{ $filters.capitalize(scope.row.type) }}
          </el-tag>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Email -->
      <el-table-column label="Email" width="330">
        <template #default="scope">
          <el-link
            type="primary"
            :href="`mailto:${scope.row.email}`"
            size="mini"
          >
            {{ scope.row.email }}
          </el-link>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Is Active -->
      <el-table-column align="center" label="Is Active" width="130">
        <template #default="scope">
          <el-switch :model-value="scope.row.isActive" size="mini" />
        </template>
      </el-table-column>
      <!--  -->
      <!-- Verified Email -->
      <el-table-column align="center" label="Verified Email" width="130">
        <template #default="scope">
          <el-switch :model-value="scope.row.verifiedEmail" size="mini" />
        </template>
      </el-table-column>

      <!-- Reset Score Email -->
      <el-table-column align="center" label="Reset Score" width="130">
        <template #default="scope">
          <el-tooltip content="Resets the survey score of this user.">
            <el-button
              icon="el-icon-refresh"
              is-borderless
              plain
              size="mini"
              @click="resetScore(scope.row._id)"
            >
              Reset
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Actions -->
      <el-table-column align="center" label="Actions">
        <template #default>
          <el-button
            icon="el-icon-more"
            type="primary"
            is-borderless
            circle
            plain
            size="mini"
          />
        </template>
      </el-table-column>
      <!--  -->
    </el-table>
  </div>
</template>

<script lang="ts">
import { ErrorUtil, User } from "@/shared";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Options({
  components: {},
})
export default class extends Vue {
  @Prop()
  users?: Array<User>;

  @Prop({ type: Boolean })
  loading?: boolean;

  /**
   * @param user
   */
  resetScore(user: string) {
    return this.$api.admin
      .patch(`/v1/users/${user}/score-reset`)
      .then(() => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "success",
          message: "Survey score has been reset.",
        });
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: "Could not reset the score.",
        });
      });
  }
}
</script>

<style lang="scss"></style>
